
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

const RoleBasedRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const { data, isLoading, error } = useQuery({
    queryKey: ['userRole'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        throw new Error('Not authenticated');
      }
      
      const { data, error } = await supabase
        .from('profiles')
        .select('role')
        .eq('id', user.id)
        .single();
      
      if (error) {
        throw error;
      }
      
      return data;
    }
  });
  
  useEffect(() => {
    if (isLoading || error) return;
    
    // If we have role data
    if (data) {
      if (data.role === 'creator') {
        navigate('/dashboard/creator');
      } else if (data.role === 'student') {
        navigate('/dashboard/student');
      } else {
        // No role set yet, redirect to role selection
        navigate('/choose-role');
      }
    }
  }, [data, isLoading, error, navigate]);
  
  if (error) {
    // If there's an error, redirect to student-auth with the current path
    navigate('/student-auth', { state: { from: location.pathname } });
    return null;
  }
  
  // Show loading while we figure out where to redirect
  return (
    <div className="h-screen flex flex-col items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground">Redirecting you to the right place...</p>
    </div>
  );
};

export default RoleBasedRedirect;
